// extracted by mini-css-extract-plugin
export default {"descriptionTemplate":"DescriptionTemplate__descriptionTemplate___XjPV0","closeIcon":"DescriptionTemplate__closeIcon___EIWJj"};